import { X } from 'lucide-react';
import { useEffect, useState } from 'react';

import { cn } from '@/lib/cn';
import { WA_LINKS } from '@/lib/whatsapp';

import { WhatsAppIcon } from '../common/icons';

const NUDGE_DELAY_MS = 9000;

/**
 * Persistent WhatsApp entry point.
 *
 * Collapsed to a circle by default so it never covers content, expanding into
 * a labelled nudge once — after that a dismissal is remembered for the session.
 */
export function FloatingWhatsApp() {
  const [expanded, setExpanded] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    const timer = window.setTimeout(() => setExpanded(true), NUDGE_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [dismissed]);

  return (
    <div className="fixed right-4 bottom-4 z-40 flex items-end gap-2 lg:right-6 lg:bottom-6">
      {expanded && !dismissed && (
        <div
          className={cn(
            'relative mb-1 max-w-[15rem] animate-pop-in rounded-2xl border-2 border-sand-300 bg-white p-3 pr-8 shadow-float',
          )}
        >
          <p className="font-display text-sm font-bold text-brown-900">Precisa de ajuda? 🐾</p>
          <p className="mt-0.5 text-xs leading-snug text-brown-700">
            Fale com a gente e a gente indica a ração certa para o seu pet.
          </p>

          <button
            type="button"
            onClick={() => {
              setExpanded(false);
              setDismissed(true);
            }}
            aria-label="Fechar aviso"
            className="absolute top-2 right-2 grid size-6 place-items-center rounded-md text-brown-700 transition-colors hover:bg-cream-300"
          >
            <X className="size-3.5" aria-hidden="true" />
          </button>
        </div>
      )}

      <a
        href={WA_LINKS.general}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar com a BrucePets no WhatsApp"
        className={cn(
          'grid size-12 place-items-center rounded-full bg-whats-500 text-white shadow-float hover:bg-whats-600 lg:size-14',
          'ring-4 ring-whats-500/25 transition-transform duration-300 hover:scale-110 active:scale-95',
        )}
      >
        <WhatsAppIcon className="size-6 lg:size-7" />
      </a>
    </div>
  );
}
